export const checkout = {
  paymentExpress: {
    title: 'Express Checkout',
    caption: 'or continue below to pay with a credit card'
  },
  summaryBlock: {
    title: {
      desktopView: 'Order Summary',
      mobileView: 'Summary'
    },
    productsOrderSummary: {
      showProduct: 'Show Order Summary',
      label: 'Products',
      hideProduct: 'Hide Order Summary',
      gift: 'Free Gift',
      giftPrice: 'Free',
      shipsEvery: 'Ships every',
      shipsOneTime: 'Ships once',
      frequencyUnit: 'days',
      welcomeKitRemoved: `
        <p>
          Welcome back!
          <br>Sorry, our Welcome Kit is for new customers only. Need a replacement? Reach out to our Customer Happiness team.
        </p>
      `
    }
  },
  paymentFields: {
    paymentTitle: 'Payment',
    paymentReviewTitle: 'Payment',
    paymentReviewButton: 'Edit',
    paymentPageContinueButton: 'Review Order',
    creditCardLabel: 'Credit Card',
    creditCardReviewText: '{{brand}} ending in {{last4}}',
    creditCardCustomError: "Your card's data is incomplete.",
    sepaLabel: 'SEPA Direct Debit',
    sepaReviewText: 'SEPA ending in {{name}}',
    sepaDisclaimer: `
      I hereby authorize Athletic Greens (EU) Limited to collect payments from my account by direct debit. 
      In the case of a subscription, this authorization applies to recurring payments. 
      I instruct my bank to honor direct debits issued by Athletic Greens (EU) Limited. 
      I agree that the period for the statutory pre-notification of the direct debit will be reduced to one day. 
      Note: I can request reimbursement of the amount debited within 8 weeks, starting with the respective debit date. 
      The conditions agreed with my bank apply.
    `,
    paymentPageWalletsFields: {
      deleteButton: 'Delete',
      label: 'Payment info'
    },
    walletsTotalLabel: 'Total'
  },
  shippingFields: {
    subTitle: 'Shipping Information',
    caption: 'Your order will ship in 3-5 business days.',
    email: 'Email',
    countryRegion: 'Country/region',
    firstName: 'First Name',
    lastName: 'Last Name',
    addressLine1: 'Address',
    addressLine2: 'Apartment, Suite, Etc',
    city: 'City',
    state: 'State',
    zipCode: 'Zip Code',
    phone: 'Phone',
    pccc: 'PCCC/Passport Number',
    isCreateAccount: 'Stay committed with tips, inspiration, and community.',
    submitButtonText: 'Continue to Payment',
    freeSubmitButtonText: 'Review Order',
    reviewTitle: 'Shipping',
    reviewButton: 'Edit',
    subscribeOnSms: `
      <p>
        <strong>Text me when my AG1 ships and about exclusive health and science content.</strong> 
        I agree to&nbsp;receive automatically-generated marketing text messages from DrinkAG1 at my number I&nbsp;provided above.
        Consent not a condition of purchase. Msg&amp;data rates may apply. Reply HELP or STOP to opt out. 
        See our <a href="https://drinkag1.com/text-message-terms/" target="_blank" aria-label="Text Msg. Terms (Opens in a new tab)" rel="noopener">Text Msg. Terms</a>, 
        <a href="https://drinkag1.com/privacy/" target="_blank" aria-label="Privacy Policy (Opens in a new tab)" rel="noopener">Privacy Policy</a> &amp; 
        <a href="https://drinkag1.com/terms-and-conditions/" target="_blank" aria-label="Terms of Service (Opens in a new tab)" rel="noopener">Terms of Service</a>.
      </p>
    `
  },
  placeOrderFields: {
    continueButton: 'Place order',
    otpCaption: `
      <p>By placing this order, you agree to the 
        <a href="https://drinkag1.com/terms-and-conditions" target="_blank" aria-label="Terms of Service (Opens in a new tab)" rel="noopener">Terms of Service</a> 
        and&nbsp;<a href="https://drinkag1.com/privacy" target="_blank" aria-label="Privacy Policy (Opens in a new tab)" rel="noopener">Privacy Policy</a>.
      </p>
    `,
    subscriptionCaption: `
      <p>
        By placing this order, you agree to the 
        <a href="https://drinkag1.com/terms-and-conditions" target="_blank" aria-label="Terms of Service (Opens in a new tab)" rel="noopener">Terms of Service</a> 
        and&nbsp;<a href="https://drinkag1.com/privacy" target="_blank" aria-label="Privacy Policy (Opens in a new tab)" rel="noopener">Privacy Policy</a>.
        <br><br>
      </p>
      <p>
        You are purchasing a continuous subscription. You authorize Athletic Greens to charge any on-file
        payment method every 30 days at the then current rate. Your subscription will renew every 30 days
        until you cancel. You can cancel anytime before your next shipment
        by visiting your account or emailing <a href="mailto:support@drinkag1.com">support@drinkag1.com</a>.
      </p>
    `
  },
  thanksFields: {
    accountPasswordLabel: 'Password',
    minLength: 'Minimum of 8 characters',
    maxLength: 'Password is too long (maximum is 40 characters)',
    whitespace: 'Password starts or ends with spaces',
    uppercase: '1 uppercase letter',
    lowercase: '1 lowercase letter',
    number: '1 number',
    accountButtonLabelCreate: 'Create An Account',
    accountButtonLabelVisit: 'Visit My Account',
    accountButtonLabelError: 'Visit My Account',
    successMessage: `
      <h1>Welcome to Foundational Nutrition, {{customerFirstName}}!</h1>
      <p>Confirmation has been sent to: {{customerEmail}}</p>
    `,
    errorMessage: `
      <h1>Welcome to AG1</h1>
      <p>Sign in to manage your account, track orders and&nbsp;shop exclusive products.</p>
    `,
    orderDetails: `
      <p><strong>Order number:</strong> #{{orderId}}</p>
      <p><strong>Delivered to:</strong> {{customerName}}</p>
      <p>{{address}}</p></div>
    `,
    accountTitleNotCreated: `
      <h2>Create An Account</h2>
      <p>Check order status, track shipments, and more.</p>
    `,
    accountTitleCreated: `
      <h2>Create An Account</h2>
      <p>Check order status, track shipments, and more.</p>
    `
  },
  unifiedOrderReview: {
    backButton: 'Back to Shop section',
    shippingFieldsTitle: 'Shipping Information',
    shippingMethodSubTitle: 'Shipping Method',
    frequencySubTitle: 'Shipping Frequency',
    frequencyText: 'Every {{frequency}}',
    frequencyUnit: 'day',
    paymentTitle: 'Payment',
    paymentSubTitle: 'Payment Method',
    billingAddressSubTitle: 'Billing Address',
    billingAddressDescription: 'Same as shipping address',
    placeOrderButton: 'Place order',
    commonCaption: `
    <p>
      You are purchasing a continuous subscription. You authorize Athletic Greens to charge any on-file payment method every {{order_frequency_days}} days at the then current rate.
      Your subscription will renew every {{order_frequency_days}} days until you cancel.
      You can cancel anytime before your next shipment by visiting your account or emailing <a href="mailto:support@drinkag1.com">support@drinkag1.com</a>.
    </p>
  `,
    giftTitle: 'Send as a gift',
    giftRecipientEmailLabel: 'Recipient Email*',
    giftMessageLabel: 'Gift Message',
    shippingAddressTitle: 'Address Info',
    shippingAddressText: "Add the recipient's name and address"
  },
  thanksFieldsMembers: {
    successMessage: `
      <h1>Hooray, your order is in!</h1>
      <p>Confirmation has been sent to: {{customerEmail}}</p>
    `,
    successMessageGift: `
      <h1>Hooray, your gift order is confirmed!</h1>
      <p>An order confirmation email has been sent to: {{customerEmail}}  and {{giftRecipientEmail}}</p>
    `,
    successMessageFreeGift: `
      <h1>Thanks for Sharing!</h1>
      <p>Email confirmation has been sent to: {{customerEmail}}  and {{giftRecipientEmail}}</p>
    `,
    orderDetails: `
      <p><strong>Order number:</strong> #{{orderId}}</p>
      <p><strong>Delivered to:</strong> {{customerName}}</p>
      <p>{{address}}</p></div>
    `,
    giftOrderDetails: `
      <p><strong>Order number:</strong> #{{orderId}}</p>
      <p><strong>Order type:</strong> Share Free Packs</p>
      <p><strong>Total:</strong> {{total}}</p>
      <p><strong>Delivered to:</strong> {{customerName}}</p>
      <p>{{address}}</p></div>
      <p>{{email}}</p></div>
    `,
    giftOrderDetailsPaid: `
    <p><strong>Order number:</strong> #{{orderId}}</p>
    <p><strong>Delivered to:</strong> {{customerName}}</p>
    <p><strong>Email:</strong> {{email}}</p>
    <p>{{address}}</p></div>
    `,
    viewOrderButtonLabel: 'View Order Details',
    shareMorePacksButtonLabel: 'Share More Packs',
    giftMessageTitle: 'Gift Message:'
  },
  // If Sanity does not work
  header: {
    title: 'CHECKOUT',
    editOrder: 'Edit Order'
  },
  footer: {
    links: [
      { url: 'https://drinkag1.com/privacy', target: true, text: 'Privacy Policy' },
      { url: 'https://drinkag1.com/terms-and-conditions', target: true, text: 'Terms of Service' }
    ]
  }
};
